import { server, url } from '@/helpers';
import { DealDetailByErpIdResponse, DealDetailsResponse } from './types/dealDetails';
import { DealsSearchPreviewResponse, DealsSearchResultsResponse } from './types/dealSearch';

export interface IDealsService {
  searchLanding(args: {
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchPreviewResponse>;
  searchPreview(args: {
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchPreviewResponse>;
  search(args: {
    type: 'deals' | 'sistaminuten';
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchResultsResponse>;
  searchBranded(args: {
    brandSlug: string;
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchResultsResponse>;
  details(args: { id: string; signal?: AbortSignal }): Promise<DealDetailsResponse>;
  detailsByErpId(args: { id: string }): Promise<DealDetailByErpIdResponse>;
}

export const DEALS_SEARCH_LANDING_ENDPOINT = '/search/deals-campaigns/landing' as const;
export const DEALS_SEARCH_ENDPOINT = '/search/deals-campaigns' as const;
export const DEALS_DETAILS_ENDPOINT = '/deal-campaign' as const;
const DEALS_DETAILS_BY_ERPID_ENDPOINT = `${DEALS_DETAILS_ENDPOINT}/find-by-erpid` as const;

export const dealsService: IDealsService = {
  async searchPreview({
    params,
    signal,
  }: {
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchPreviewResponse> {
    return server.request
      .get(DEALS_SEARCH_ENDPOINT, { params, paramsSerializer: url.serialize, signal })
      .then((response) => response.data);
  },

  async search({
    type,
    params,
    signal,
  }: {
    type: 'deals' | 'sistaminuten';
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchResultsResponse> {
    return server.request
      .get(`${DEALS_SEARCH_ENDPOINT}/${type}`, { params, paramsSerializer: url.serialize, signal })
      .then((response) => response.data);
  },

  async searchBranded({
    brandSlug,
    params,
    signal,
  }: {
    brandSlug: string;
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchResultsResponse> {
    return server.request
      .get(`${DEALS_SEARCH_ENDPOINT}/brand_deals/${brandSlug}`, { params, paramsSerializer: url.serialize, signal })
      .then((response) => response.data);
  },

  async searchLanding({
    params,
    signal,
  }: {
    params?: Record<string, string | number>;
    signal?: AbortSignal;
  }): Promise<DealsSearchPreviewResponse> {
    return server.request.get(DEALS_SEARCH_LANDING_ENDPOINT, { params, signal }).then((response) => response.data);
  },

  async details({ id, signal }: { id: string; signal?: AbortSignal }): Promise<DealDetailsResponse> {
    return server.request.get(`${DEALS_DETAILS_ENDPOINT}/${id}`, { signal }).then((response) => response.data);
  },

  async detailsByErpId({ id }: { id: string }): Promise<{ redirect: string }> {
    return server.request.get(`${DEALS_DETAILS_BY_ERPID_ENDPOINT}/${id}`).then((response) => response.data);
  },
};
